import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import Loading from "../views/Loading.vue";
import Guide from "../views/Guide.vue";
import Introduce from "../views/Introduce.vue";
import Pcview from "../views/Pcview.vue";
import store from "../store/";

Vue.use(VueRouter);

const routes = [
  {
    path: "/pc",
    name: "pc",
    meta: { index: 5 },
    component: Pcview,
  },
  {
    path: "/",
    name: "login",
    meta: { index: 0 },
    component: Login,
  },
  {
    path: "/home",
    name: "home",
    meta: { index: 1 },
    component: Home,
  },
  {
    path: "/loading",
    name: "loading",
    meta: { index: 2 },
    component: Loading,
  },
  {
    path: "/Guide",
    name: "guide",
    meta: { index: 3 },
    component: Guide,
  },
  {
    path: "/Introduce",
    name: "introduce",
    meta: { index: 4 },
    component: Introduce,
  },
  {
    path: "/about",
    name: "about",
    meta: { index: 5 },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  let isLogin = store.getters.checkLogin(store.state);
  const route = ["/", "login"];
  if (route.indexOf(to.name) < 0 && !isLogin) {
    router.push("/");
    return;
  }

  next();
});

export default router;
